<!--
 * @Author: wsx
 * @Date: 2022-01-16 15:32:58
 * @LastEditTime: 2022-01-21 16:33:05
 * @LastEditors: your name
 * @Description:视频组件
-->
<template>
  <div class="HVideo">
    <div
      ref="videoRef"
      id="videoClient"
      v-resize="resize"
      class="videoClient"
    ></div>
    <div class="tool" v-if="showTool">
      <div class="tool-left">
        <!--

        <h-button @click="stopPreview">关闭</h-button> -->
      </div>
      <div class="tool-right">
        <h-icon
          class="video-icon"
          title="截图"
          @click="screenshot"
          icon="icon-jietu"
        ></h-icon>
        <el-popover
          v-model:visible="layoutVisible"
          placement="left"
          :width="940"
          trigger="click"
        >
          <template #reference>
            <h-icon
              class="video-icon"
              title="分割窗口"
              icon="icon-kuaisubuju"
            ></h-icon>
          </template>
          <ul class="layout-list">
            <template v-for="item in layoutIcon" :key="item.id">
              <li
                @click="setLayout(item)"
                class="layout-item"
                :class="{ current: current === item.id }"
              >
                <h-icon :icon="item.icon"></h-icon>
                <span class="text">{{ item.id }}</span>
              </li>
            </template>
          </ul>
        </el-popover>
        <h-icon
          class="video-icon"
          title="全屏"
          @click="fullScreen"
          icon="icon-quanping"
        ></h-icon>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  nextTick,
  reactive,
  toRefs,
  ref,
  watchEffect,
} from "vue";
import { useContext } from "@/hooks/core/useContext";
import util from "@util/js";
export default defineComponent({
  name: "HVideo",
  props: {
    layout: {
      type: Number,
      default: 4,
    },
    showTool: {
      type: Boolean,
      default: true,
    },
    videoConnected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const state = reactive({
      layoutVisible: false,
      current: 4,
      layoutIcon: [
        {
          id: 1,
          icon: "icon-layout1",
        },
        {
          id: 2,
          icon: "icon-layout2",
        },
        {
          id: 3,
          icon: "icon-layout3",
        },
        {
          id: 4,
          icon: "icon-layout4",
        },
        {
          id: 5,
          icon: "icon-layout5",
        },
        {
          id: 6,
          icon: "icon-layout6",
        },
        {
          id: 7,
          icon: "icon-layout7",
        },
        {
          id: 8,
          icon: "icon-layout8",
        },
        {
          id: 9,
          icon: "icon-layout9",
        },
        {
          id: 10,
          icon: "icon-layout10",
        },
        {
          id: 11,
          icon: "icon-layout11",
        },
        {
          id: 12,
          icon: "icon-layout12",
        },
        {
          id: 13,
          icon: "icon-layout13",
        },
        {
          id: 14,
          icon: "icon-layout14",
        },
        {
          id: 15,
          icon: "icon-layout15",
        },
        {
          id: 16,
          icon: "icon-layout16",
        },
      ],
    });
    const refData = toRefs(state);
    const videoRef = ref(null);
    const videoClient = useContext("videoClient");
    watchEffect(() => {
      if (props.videoConnected) {
        nextTick(() => {
          initVideo();
        });
      }
    });
    const initVideo = () => {
      if (props.videoConnected) {
        videoClient.initVideo(videoRef.value, { layout: props.layout });
      }
    };

    // dom节点大小变化
    const resize = () => {
      videoClient.resize(videoRef.value);
    };
    onMounted(() => {
      nextTick(() => {
        initVideo();
      });
    });
    onBeforeUnmount(() => {
      videoClient.unInit();
      videoClient.hide();
    });
    // 隐藏
    const hide = () => {
      videoClient.hide();
    };
    // 显示
    const show = async (item) => {
      videoClient.show();
    };
    // 设置布局
    const setLayout = async (item) => {
      state.current = item.id;
      await videoClient.setLayout(item.id);
      state.layoutVisible = false;
    };
    // 截图
    const screenshot = async () => {
      const res = await videoClient.snapSelectAndUpload();
      const { baseStr, imgName } = res;
      const imgUrl = "data:image/jpg;base64," + baseStr;
      util.downBaseFile(imgName, imgUrl);
    };
    const close = () => {
      videoClient.stopPreview([0]);
    };
    /**
     * 播放摄像机视频
     * @param {array} lsit 摄像机数据
     * @param {string} id 摄像机id字段
     */
    const play = async (lsit, id = "cameraId") => {
      // await videoClient.playCamera(lsit, id);
      await videoClient.startPreview(lsit);
    };
    /**
     * @Description: 视频回放
     * @param {array} params
     * [{
     *  @param cameraId 摄像头id
     *  @param startTime 回放开始时间
     *  @param endTime 回放结束时间
     * }]
     */
    const playback = async (lsit) => {
      // await videoClient.playbackCamera(lsit);
      await videoClient.startPlayback(lsit);
    };
    // 全屏
    const fullScreen = async () => {
      await videoClient.maximized();
    };
    // 获取布局
    const getCurLayout = async () => {
      let res = await videoClient.getCurLayout();
      if (res.code == 0) {
        return res.returnValue;
      }
    };
    // 获取当前布局所有摄像机信息
    const getCameraList = async () => {
      let res = await videoClient.getCameraList();
      if (res.code == 0) {
        return res.returnValue;
      }
    };
    return {
      ...refData,
      videoRef,
      hide,
      show,
      setLayout,
      resize,
      screenshot,
      play,
      playback,
      fullScreen,
      close,
      getCurLayout,
      getCameraList,
    };
  },
});
</script>
<style lang="scss" scoped>
.HVideo {
  width: 100%;
  height: 100%;
  @include flex-col-s-s;

  .videoClient {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #000;
  }
  .tool {
    height: 60px;
    width: 100%;
    background-color: #323233;
    color: #fff;
    @include flex-row-sb-c;
    .video-icon {
      font-size: 18px;
      margin: 0 10px;
      cursor: pointer;
    }
  }
}
.layout-list {
  @include flex-row-sb-c;
  .layout-item {
    border: 1px solid var(--el-border-color-base);
    border-radius: 3px;
    padding: 3px 5px;
    cursor: pointer;
    &:hover,
    &.current {
      color: var(--el-color-primary);
      background-color: var(--el-color-primary-light-5);
    }
    .text {
      margin-left: 5px;
    }
  }
}
</style>
